var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['loadingScreen/getLoading'])?_c('div',{staticClass:"loader-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"borda-1"}),_vm._v(" "),_c('div',{staticClass:"borda-2"}),_vm._v(" "),_c('div',{staticClass:"logo-empresa"},[_c('img',{attrs:{"src":"/img/logo/ugt_logo.png","alt":"UGT-SP"}})])])
}]

export { render, staticRenderFns }